import { useDataChange } from 'Simple/Data.js'

export function useOnClick(props) {
  let change = useDataChange({
    context: 'tab',
    path: 'selected.ledger.payors',
    viewPath: props.viewPath,
  })

  return function onClick() {
    change([])
  }
}
